import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";  // 
const Footer = () => {
   const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
    
  useEffect(() => {
        loadLanguageFile("Footer", "Footer_lang"); 
  }, [language]);
    
  const LANGUAGE = componentLanguageData.Footer || { Main: {} };
  return (
    <div
      className="container-fluid bg-dark text-light mt-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp' }}
    >
      <div className="container">
        <div className="row gx-5">
          {/* 左側 - 關於我們 */}
          <div className="col-lg-4 col-md-6 footer-about">
            <div className="d-flex flex-column align-items-center justify-content-center text-center h-100 bg-primary p-4">
              <a href="/" className="navbar-brand">
                <h1 className="m-0 text-white">
                  <img
                    src="/img/logo.png"
                    alt="Logo"
                    style={{ maxHeight: '45px', width: 'auto', marginBottom: '15px',marginRight: '1%' }}
                  />
                  {LANGUAGE.Main.Content1}
                </h1>
              </a>
              <p className="mt-3 mb-4">
              {LANGUAGE.Main.Content2}
              </p>
              <p className="mt-3 mb-4">
              {LANGUAGE.Main.Content2_1}
              </p>
              <div className="d-flex mb-4 justify-content-center align-items-center">
                <h5 className="text-white mb-0 me-3">{LANGUAGE.Main.Content21}:</h5>
                <a
                  className="btn btn-light btn-square rounded-circle me-2 social-hover"
                  href="https://www.threads.net/@mas_ai_trader"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Threads"
                  style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.3s' }}
                >
                  <svg aria-hidden="true" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor">
                    <path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z" />
                  </svg>
                </a>
                <a
                  className="btn btn-light btn-square rounded-circle social-hover"
                  href="https://www.instagram.com/mas_ai_trader/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                  style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.3s' }}
                >
                  <svg aria-hidden="true" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8.001 16c2.172 0 2.444-.01 3.298-.048.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {/* 右側 - 其他區塊 */}
          <div className="col-lg-8 col-md-6">
            <div className="row gx-5">
              {/* 聯繫方式 */}
              <div className="col-lg-4 col-md-12 pt-5 mb-5">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                  <h3 className="text-light mb-0">{LANGUAGE.Main.Content5}</h3>
                </div>
                <div className="d-flex mb-2">
                  <i className="bi bi-geo-alt text-primary me-2"></i>
                  <p className="mb-0">{LANGUAGE.Main.Content6}</p>
                </div>
                <div className="d-flex mb-2">
                  <i className="bi bi-envelope-open text-primary me-2"></i>
                  <p className="mb-0">{LANGUAGE.Main.Content7}</p>
                </div>
                {/* <div className="d-flex mb-2">
                <a href={`tel:${LANGUAGE.Main.Content8}`}><i className="bi bi-telephone text-primary me-2"></i></a>
                <a href={`tel:${LANGUAGE.Main.Content8}`}><p className="mb-0">{LANGUAGE.Main.Content8}</p></a>
                </div> */}
              </div>
              {/* 快速連結 */}
              <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                  <h3 className="text-light mb-0">{LANGUAGE.Main.Content9}</h3>
                </div>
                <div className="link-animated d-flex flex-column justify-content-start">
                  <a className="text-light mb-2" href="/">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content10}
                  </a>
                  <a className="text-light mb-2" href="/about">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content11}
                  </a>
                  <a className="text-light mb-2" href="/partners">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content15}
                  </a>
                  <a className="text-light mb-2" href="/service">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content12}
                  </a>
                  <a className="text-light mb-2" href="/team">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content13}
                  </a>
                  <a className="text-light" href="/contact">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content14}
                  </a>
                </div>
              </div>
              {/* 條款連結區塊 */}
              <div className="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                  <h3 className="text-light mb-0">{LANGUAGE.Main.Content15_2}</h3>
                </div>
                <div className="link-animated d-flex flex-column justify-content-start">
                  <a className="text-light mb-2" href="/terms_api">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content16}
                  </a>
                  <a className="text-light mb-2" href="/terms_payment">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content17}
                  </a>
                  <a className="text-light mb-2" href="/terms_disclaimer">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content18}
                  </a>
                  <a className="text-light mb-2" href="/terms_platform">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content19}
                  </a>
                  <a className="text-light" href="/terms_privacy">
                    <i className="bi bi-arrow-right text-primary me-2"></i>{LANGUAGE.Main.Content20}
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div
          className="text-center text-light py-4 mt-2"
          style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}
        >
          <p className="mb-0">{LANGUAGE.Main.Copyright}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
